<template>
	<div style="background-color: rgb(248, 248, 248); color: rgb(51, 51, 51);">
		<div><!---->
			<div data-v-1240e8ed="" class="header">
				<div data-v-1240e8ed="" class="van-nav-bar">
					<div class="van-nav-bar__content">
						<div class="van-nav-bar__left" @click="fanhui()"><i
								class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i></div>
						<div class="van-nav-bar__title van-ellipsis">{{$t('记录')}}</div>
					</div>
				</div>
			</div>
		</div>
		<div data-v-1240e8ed="" class="records-center ypage-box">
			<div class="van-tabs van-tabs--line">
				<div class="van-tabs__wrap">
					<div role="tablist" class="van-tabs__nav van-tabs__nav--line">
						<div role="tab" aria-selected="true" class="van-tab van-tab--active" @click="qiehuan(1)"><span
								class="van-tab__text van-tab__text--ellipsis">{{$t('兑换')}}</span>
						</div>




						<div role="tab" aria-selected="true" class="van-tab van-tab--active" @click="qiehuan(2)"><span
								class="van-tab__text van-tab__text--ellipsis">{{$t('提取')}}</span></div>

						<div class="van-tabs__line" style="transform: translateX(95px) translateX(-50%);"
							v-show="duihuan_xia">
						</div>

						<div class="van-tabs__line" style="transform: translateX(292px) translateX(-50%);"
							v-show="tiqu_xia">
						</div>
					</div>
				</div>
				<div class="van-tabs__content van-tabs__content--animated">
					<div class="van-tabs__track"
						style="transform: translate3d(0%, 0px, 0px); transition-duration: 0.3s;">
						<div role="tabpanel" class="van-tab__pane-wrapper">
							<div class="van-tab__pane"></div>
						</div>
						<div role="tabpanel" aria-hidden="true"
							class="van-tab__pane-wrapper van-tab__pane-wrapper--inactive">
							<div class="van-tab__pane"><!----></div>
						</div>
						<div role="tabpanel" aria-hidden="true"
							class="van-tab__pane-wrapper van-tab__pane-wrapper--inactive">
							<div class="van-tab__pane"><!----></div>
						</div>
						<div role="tabpanel" aria-hidden="true"
							class="van-tab__pane-wrapper van-tab__pane-wrapper--inactive">
							<div class="van-tab__pane"><!----></div>
						</div>
					</div>
				</div>
			</div>
			<div data-v-3e39609a=""
				class="tb-header van-row van-row--flex van-row--align-center van-row--justify-space-between"
				style="border-left: none; border-right: none;">
				<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">{{$t('币种')}}
				</div>
				<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">{{$t('金额')}}
				</div>
				<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">{{$t('状态')}}

				</div>
				<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">{{$t('时间')}}

				</div>
			</div>
			<div data-v-1240e8ed="" class="pad-wrap">
				<div data-v-1cf09a36="" data-v-1240e8ed="">
					<div v-show="duihuan_log_list_div" data-v-1cf09a36="" class="no-data"
						style="height: 35px;border-bottom:1px solid #efefef;margin-top:5px;"
						v-for="item in duihuan_log_data" :key="item">
						<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">
							{{item.type == 'erc' ? 'ETH' : 'BNB'}}
						</div>
						<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">
							{{item.usdt_num}}
						</div>
						<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">
							{{item.status}}
						</div>
						<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">
							{{item.addtime}}
						</div>
					</div>


					<div v-show="tixian_log_list_div" data-v-1cf09a36="" class="no-data"
						style="height: 35px;border-bottom:1px solid #efefef;margin-top:5px;"
						v-for="item in tixian_log_data" :key="item">
						<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">
							{{item.type == 'erc' ? 'ETH' : 'BNB'}}
						</div>
						<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">
							{{item.price}}
						</div>
						<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">
							{{item.status_ts}}
						</div>
						<div data-v-3e39609a="" class="van-col van-col--6" style="text-align: center;">
							{{item.updated_at}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import axios from 'axios'

	import domain from '../../public/domain';

	export default {
		name: 'App',
		data() {
			return {
				duihuan_log_data: [],
				tixian_log_data: [],
				duihuan_xia: true,
				tiqu_xia: false,
				duihuan_log_list_div: true,
				tixian_log_list_div: false,
				xz_lang:''
			}
		},

		methods: {
			lang() {
				var lang = this.$i18n.locale
				var name = "English"
				if (lang == 'zh') {
					name = '简体中文'
				} else if (lang == 'fa') {
					name = '繁体中文'
				} else if (lang == 'en') {
					name = 'English'
				} else if (lang == 'po') {
					name = 'Português'
				} else if (lang == 'al') {
					name = 'عربي'
				} else if (lang == 'de') {
					name = 'Deutsch'
				} else if (lang == 'xi') {
					name = 'español'
				} else if (lang == 'yi') {
					name = 'Italiano'
				} else if (lang == 'el') {
					name = 'Русский'
				} else if (lang == 'ja') {
					name = '日本語'
				} else if (lang == 'tu') {
					name = 'Türkçe'
				}
				this.xz_lang = name
			},
			qiehuan(type) {
				if (type == 1) {
					this.duihuan_xia = true,
						this.tiqu_xia = false,
						this.duihuan_log_list_div = true,
						this.tixian_log_list_div = false
				} else {
					this.duihuan_xia = false,
						this.tiqu_xia = true,
						this.duihuan_log_list_div = false,
						this.tixian_log_list_div = true
				}
			},
			tz(url) {
				window.location.href = '/#'+url
			},
			fanhui() {
				window.history.go(-1);
			},
			duihuan_log() {
				var lang = this.$i18n.locale
				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var im = this
				axios({
						method: 'post',
						url: domain.publicUrl + "/api/api/duihuan_log",
						data: {
							address: address,
							type: newtype,
							lang: lang
						},
					})
					.then(function(response) {
						im.duihuan_log_data = response.data.data

					})
					.catch(function(error) {
						console.log(error);
					});
			},

			tixian_log() {

				var lang = this.$i18n.locale
				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {
					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var im = this
				axios({
						method: 'post',
						url: domain.publicUrl + "/api/api/tixian_log",
						data: {
							address: address,
							type: newtype,
							lang: lang
						},
					})
					.then(function(response) {
						im.tixian_log_data = response.data.data

					})
					.catch(function(error) {
						console.log(error);
					});

			},
			fn() {
				var lang_type = sessionStorage.getItem("lang_type");
				var name = "English"
				if(!lang_type){
					name = "English"
				}else{
					if (lang_type == 'zh') {
						name = '简体中文'
					} else if (lang_type == 'fa') {
						name = '繁体中文'
					} else if (lang_type == 'en') {
						name = 'English'
					} else if (lang_type == 'po') {
						name = 'Português'
					} else if (lang_type == 'al') {
						name = 'عربي'
					} else if (lang_type == 'de') {
						name = 'Deutsch'
					} else if (lang_type == 'xi') {
						name = 'español'
					} else if (lang_type == 'yi') {
						name = 'Italiano'
					} else if (lang_type == 'el') {
						name = 'Русский'
					} else if (lang_type == 'ja') {
						name = '日本語'
					} else if (lang_type == 'tu') {
						name = 'Türkçe'
					}
				}
				
				
				this.xz_lang = name
			},
		},
		mounted: function() { //自动触发写入的函数
			this.duihuan_log();
			this.tixian_log();
			this.lang();
			this.fn();
		}
	}
</script>


<style>
</style>